import {
  COLLABORATE_EXTERNAL_KEYS,
  SUBSCRIPTION_TYPES,
  SUBSCRIPTION_STATUS,
} from './const';
import { User, Subscription } from './types';

export const isPaidSubscription = (
  subscription: Subscription,
  subscriptions: Subscription[],
) =>
  subscriptions.some(
    (current) =>
      !!current.offeringName &&
      current.offeringName === subscription.offeringName &&
      current.status === SUBSCRIPTION_STATUS.ACTIVE &&
      current.type !== SUBSCRIPTION_TYPES.TRIAL,
  );

const camelize = (str: string) => {
  return str
    .toLowerCase()
    .replace(/[^a-z\d]+(.)/gi, (m, chr) => chr.toUpperCase());
};

const generateProductName = (trial: Subscription) => {
  if (trial.offeringExternalKey === COLLABORATE_EXTERNAL_KEYS.COLLABORATE_PRO) {
    return trial.offeringCategoryName + ' Pro';
  }
  return trial.offeringCategoryName;
};

const reducer = (
  result: { [key: string]: string | number },
  trial: Subscription,
  index: number,
) => {
  result.trialsDisplayed = `${result.trialsDisplayed}${
    index !== 0 ? ', ' : ''
  }${generateProductName(trial)}`;
  result[`${camelize(generateProductName(trial))}TrialDaysRemaining`] =
    trial.daysRemaining;
  return result;
};

const generateTrialsTrackingData = (trials: Subscription[]) => {
  return trials.reduce(reducer, { trialsDisplayed: '' });
};

export const getTrackingProperties = (
  user: User | null,
  trials: Subscription[],
  currentProductId: string,
) => ({
  modalOpenTimeStamp: new Date(Date.now()).toISOString(),
  currentPage: currentProductId,
  currentUserEmailDomain:
    user && user.email.substring(user.email.lastIndexOf('@') + 1),
  ...generateTrialsTrackingData(trials),
});

export const addDaysToDate = (date: Date, days: number) => {
  const result = new Date(date);
  return result.setDate(result.getDate() + days);
};

export const shouldShowExpiredMessage = (trials: Subscription[]) => {
  const lastTrialExpired = trials.reduce(
    (result: Subscription, trial: Subscription) => {
      if (result) {
        return new Date(result.endDate) < new Date(trial.endDate)
          ? trial
          : result;
      }

      return trial;
    },
  );
  const trialBannerHideDate = addDaysToDate(
    new Date(lastTrialExpired.endDate),
    1,
  );
  const today = new Date(Date.now()).setHours(0, 0, 0, 0);

  return today <= trialBannerHideDate;
};
